export const PRISM_CSS_CLASSNAME = 'prism-css'
export const PRISM_BUTTON_CLASS = 'prism-button'
export const PRISM_SESSION_VIEW = 'prism-session-view'

/* ENV Keys Types */
export enum DeploymentType {
  CDN = 'cdn',
  PACKAGE = 'package',
  LOCAL = 'local',
}
